import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RoundButton from '../../../Common/RoundButton';
import { useHistory } from 'react-router-dom';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
// import { Box } from '@material-ui/core';
import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { logFirebaseEvent } from '../firebase';
import { P2P_HELP_VIEW, P2P_RAISE_TCK_BTN } from '../firebase/constant';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import RecentTransactionsIcon from '../../../utils/assests/recent-transaction-icon.png';
const Faq = () => {
  useEffect(() => {
    document.title = 'stashearn - faq';
  }, []);

  const history = useHistory();

  useEffect(() => {
    logFirebaseEvent(P2P_HELP_VIEW);
  }, []);
  const handleProceed = () => {
    logFirebaseEvent(P2P_RAISE_TCK_BTN);
    history.push('/p2p/faqHelp');
  };

  const faqData = [
    {
      title: 'What is StashEarn?',
      descripation:
        'StashEarn is a new-age peer to peer (P2P) investment platform, built in partnership with LiquiLoans, an RBI registered NBFC-P2P. StashEarn provides you with a diversified portfolio of creditworthy borrowers, designed to get you high returns on your investment in a convenient and hassle-free manner.',
    },
    {
      title: 'What is peer to peer lending?',
      descripation:
        'Peer to peer lending is an alternate method of financing that allows you (investor) to directly connect with creditworthy borrowers. For individual investors, P2P lending is a way to get better returns on their cash savings than a bank savings account or other traditional modes of investment.',
    },
  ];

  const faqData2 = [
    {
      title: 'How does StashEarn manage my risk?',
      descripation: `Our proprietary risk model uses 500+ data points to assess the borrower’s risk profile and provides you with a portfolio of creditworthy borrowers. These data points include both traditional and alternate forms of data.

      Through diversification we divide your investments among multiple borrowers to mitigate risk in case of any defaults.`,
    },
    {
      title: 'What is the expected rate of return?',
      descripation: `While the returns vary from investor to investor, our NBFC-P2P partner - Liquiloans, has historically given upto 10.5% - 12% (depending upon plan selection) p.a returns. To know more about the plan, visit: Liquiloans`,
    },
    {
      title: 'What is the maximum amount I can invest?',
      descripation:
        'Maximum investment amount is Rs.10,00,000 and minimum investment amount is Rs. 10,000. The registration is absolutely free.',
    },
    {
      title: 'Can I withdraw my investment earlier than the selected tenure?',
      descripation:
        'Once an investment is made your investment can not be withdrawn before the lock-in period. This is to assure your investment yields maximum returns.',
    },
  ];

  return (
    <>
      <BackgroundTheme>
        <Card className='redBorder'>
          <CardContent>
            <Grid
              container
              alignItems='center'
              justifyContent='center'
              columnSpacing={2}
              className='smallCardHeading'
            >
              <Grid item>
                <img src={RecentTransactionsIcon} alt='' />
              </Grid>
              <Grid item>
                <Typography variant='h2'>
                  Frequently <br />
                  asked questions
                </Typography>
              </Grid>
            </Grid>

            <div className='faqAccordion'>
              {faqData.length > 0 &&
                faqData.map((item) => {
                  return (
                    <>
                      <Accordion disableGutters={false}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon className='icon-styles-accordion' />
                          }
                          aria-controls='panel1a-content'
                          id='panel1a-header'
                        >
                          <Typography>{item.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>{item.descripation}</Typography>
                        </AccordionDetails>
                      </Accordion>
                    </>
                  );
                })}
              <Accordion disableGutters={false}>
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon className='icon-styles-accordion' />
                  }
                  aria-controls='panel1a-content'
                  id='panel1a-header'
                >
                  <Typography>
                    How can I become an investor on StashEarn?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Becoming an investor on StashEarn is simple:
                    <br />
                    <ol>
                      <li>Provide few basic details</li>
                      <li>Upload your KYC documents</li>
                      <li>Get your StashEarn account verified</li>
                    </ol>
                    Approval of your application is usually automated and
                    instant. Once your investor application is approved, you can
                    login, click on ‘Add Funds’ to transfer money to your
                    StashEarn account and start tracking your investment
                  </Typography>
                </AccordionDetails>
              </Accordion>
              {faqData2.length > 0 &&
                faqData2.map((item) => {
                  return (
                    <>
                      <Accordion disableGutters={false}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon className='icon-styles-accordion' />
                          }
                          aria-controls='panel1a-content'
                          id='panel1a-header'
                        >
                          <Typography>{item.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>{item.descripation}</Typography>
                        </AccordionDetails>
                      </Accordion>
                    </>
                  );
                })}
            </div>
            <Box className='faqBottomText'>
              <div className='text-center '>
                <a
                  className='remove-underline'
                  target='_blank'
                  href='https://www.liquiloans.com/faq#ques1'
                >
                  to know more refer to our NBFC-P2P partner <br /> LiquiLoans
                  FAQs
                </a>
                <Typography>
                  if you still require <br />
                  support create a ticket and our customer
                  <br />
                  support executive will contact you shortly
                </Typography>
              </div>
            </Box>

            <RoundButton onClick={handleProceed} title='raise a ticket' />
          </CardContent>
        </Card>
      </BackgroundTheme>
    </>
  );
};

export default Faq;
